<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import {
  getClaimList,
  addClaim,
  editClaim,
  deleteClaim
} from "@/api/claim_management/claim_pool";

import cTable from "@/base/common/index";
export default {
  name: "claim_pool",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        list: getClaimList,
        addClaim,
        editClaim,
        deleteClaim
      },
      config: {
        height: 630
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "name cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ airway_number: 24 }, { remarks: 24 }],
          fields: [
            {
              name: () => this.$t("orderNum"),
              key: "airway_number",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("orderNum");
              },
              bind: {
                type: "textarea",
                autosize: { minRows: 2 }
              }
            },
            {
              name: () => this.$t("order_desc"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 2 }
              },
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              }
            }
          ]
        }
      },
      header: {
        config: {
          custom: false
        },
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 1 }
            }
          }
          // {
          //   key: "ClientId",
          //   type: "select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("clientName");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "account", value: "id" }
          // }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 922
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "addClaim";
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("orderNum"),
          key: "airway_number",
          align: "center",
          minWidth: 200
        },
        {
          name: () => this.$t("order_desc"),
          key: "remarks",
          minWidth: 160
        },
        {
          name: () => this.$t("createUser"),
          key: "create_name",
          minWidth: 160
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          minWidth: 160
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 921
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 920
              // bind: {
              //   type: "error"
              // }
            }
          ],
          methods: {
            update({ row }) {
              this.getModal("add").setTitle(this.$t("update"));
              this.getModal("add").type = "editClaim";
              this.getModal("add").open(row);
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("deleteClaim", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
